import { getInstance } from './index';
const ACCESS_TOKEN_KEY = 'accessToken';

export const authGuard = (to, from, next) => {
    console.log('authGuard')
    if (localStorage.getItem(ACCESS_TOKEN_KEY) !== null){
        return next();
    }
    const authService = getInstance();

    const fn = () => {
        console.log('fn')
        // If the user is authenticated, continue with the route
        if (authService.isAuthenticated) {
            return next();
        }

        // Otherwise, log in
        authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
    };

    // If loading has already finished, check our auth state using `fn()`
    if (!authService.loading) {
        console.log('if')
        return fn();
    }

    // Watch for the loading property to change before we check isAuthenticated
    authService.$watch('loading', loading => {
        console.log('$watch')
        if (loading === false) {
            return fn();
        }
    });
};
